// eslint-disable-next-line no-unused-vars
import { React, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLock,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'
import { userSendCode } from "../../services/authFn";
import AppLoader from "../loader/loader";

const Forgotpassword = () => {
  const showAlert = (title, text, icon) => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: 'OK'
    });
  };
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // Handle Remember Me checkbox change
  const handleRememberMeChange = () => {
    setRememberMe(!rememberMe);
  };

  // Handle Forgot Password click
  const handleForgotPassword = () => {
    alert("Redirecting to password reset page...");
    // You could redirect to a password reset page or show a modal here
  };

  const showErrorAlert = (message) => {
    Swal.fire({
      title: 'Error!',
      text: message,
      icon: 'error',
      confirmButtonText: 'OK',
    });
  };

  const handleSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.trim()) {
      showAlert('Error', "Email is required", 'error');
      return;
    }

    if (!emailRegex.test(email)) {
      showAlert('Error', "Please enter a valid email address", 'error');
      return;
    }

    const payload = {
      email,
      purpose: "Forget Password",
      role: "User",
    };
    setIsLoading(true);
    try {
      const response = await userSendCode(payload);
      if (response.data?.status === "success") {
        showAlert('Success', response?.data.message || 'success');
        navigate("/otpVerification", { state: { email } });
      } else {
        showAlert('Error', response?.data.message || 'Registration failed.', 'error');
      }
    } catch (error) {
      showAlert('Error', error?.message || 'An error occurred during OTP verification.', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <section className="forgot-section">
        <div className="forgot-hero">
          <div className="container forgot-con">
            <div className="box box-div">
              <h1 className="forgot-pg">Forgot Password</h1>
              <p>We will use this email to reset your account password</p>

              {/* Email Input */}
              <div className="input-group">
                <div className="input-container w-100">
                  <label htmlFor="email" className="input-label">
                    <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter Your Email"
                    className="input-field"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div className="col-lg-12 col-md-12 col-sm-12">
                <button className="btn-1" onClick={handleSubmit}>
                  Send Reset Otp
                </button>
              </div>

              {/* Register Link */}
              <div className="text-center mt-3">
                <p className="register-link">
                  <span onClick={() => navigate("/signin")}>Back to login</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Forgotpassword;
